import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiDownload, FiMaximize2, FiCheckCircle, FiImage } = FiIcons;

export default function PreviewPanel({ preview, isRendering, onDownload, sponsorsCount, photoName }) {
  return (
    <section className="preview-panel">
      <div className="preview-header">
        <div><span className="eyebrow">REZULTAT FINAL</span><h2>Previzualizare</h2></div>
        <span className="live-badge"><span /> Live preview</span>
      </div>
      <div className={`preview-stage ${preview ? 'ready' : ''}`}>
        {preview ? <img src={preview} alt="Previzualizarea imaginii finale cu banda sponsorilor" /> : (
          <div className="preview-empty">
            <div className="preview-placeholder-icon"><SafeIcon icon={FiImage} /></div>
            <h3>Imaginea ta va apărea aici</h3>
            <p>Încarcă o fotografie pentru a vedea cum arată postarea completă cu sponsorii echipei.</p>
            <div className="placeholder-lines"><span /><span /><span /></div>
          </div>
        )}
        {isRendering && <div className="render-overlay">Se pregătește previzualizarea...</div>}
      </div>
      <div className="preview-footer">
        <div className="preview-details">
          <span><SafeIcon icon={FiMaximize2} /> Rezoluție originală</span>
          <span><SafeIcon icon={FiCheckCircle} /> {sponsorsCount} {sponsorsCount === 1 ? 'sponsor' : 'sponsori'}</span>
        </div>
        <button className="download-button" type="button" disabled={!preview || isRendering} onClick={onDownload}>
          <SafeIcon icon={FiDownload} /> Descarcă imaginea finală
        </button>
        <p className="download-note">{photoName ? 'Export PNG la calitatea imaginii încărcate.' : 'Încarcă o imagine pentru a activa descărcarea.'}</p>
      </div>
    </section>
  );
}